export function getLocalStorageItem(key) {
  return JSON.parse(localStorage.getItem(key)) || [];
}

export function setLocalStorageItem(key, data) {
  return localStorage.setItem(key, JSON.stringify(data));
}
